import { render, staticRenderFns } from "./ModalWrapper.vue?vue&type=template&id=c6952664&scoped=true"
import script from "./ModalWrapper.vue?vue&type=script&lang=js"
export * from "./ModalWrapper.vue?vue&type=script&lang=js"
import style0 from "./ModalWrapper.vue?vue&type=style&index=0&id=c6952664&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6952664",
  null
  
)

export default component.exports